import { render } from "./FormTextarea.vue?vue&type=template&id=d88344ce"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
script.render = render

export default script